import { render, staticRenderFns } from "./StructuredMoreFiltersDependers.vue?vue&type=template&id=81aa1fea&scoped=true&"
import script from "./StructuredMoreFiltersDependers.vue?vue&type=script&lang=js&"
export * from "./StructuredMoreFiltersDependers.vue?vue&type=script&lang=js&"
import style0 from "./StructuredMoreFiltersDependers.vue?vue&type=style&index=0&id=81aa1fea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81aa1fea",
  null
  
)

export default component.exports